import React, { useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogContent, Typography, TextField, Button, IconButton } from "@material-ui/core";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.surface.primary,
    width: 416,
    height: 706,
    borderRadius: 16,
  },
  contentWrap: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  title: {
    color: '#FDFDFD',
    fontFamily: 'DM Sans',
    fontWeight: 700,
    fontSize: 28,
    lineHeight: '36px',
    margin: '36px 0 16px 0',
  },
  closeLink: {
    color: '#A3A2FF',
    fontWeight: 700,
    cursor: 'pointer',
  },
  subTitle: {
    color: '#FDFDFD',
    fontSize: 14,
    fontWeight: 600,
    opacity: 1,
    marginBottom: 16,
  },
  field: {
    marginTop: 8,
    background: '#2B2B31',
    borderRadius: 6,
  },
  inputInner: {
    paddingLeft: 24,
  },
  fieldFlex: {
    flex: 1,
  },
  fieldLabel: {
    color: theme.text.subtitle,
    fontSize: 12,
    marginBottom: 4,
  },
  inputRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  percentSuffix: {
    color: '#FDFDFD',
    marginTop: 8,
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 16,
    gap: 16,
  },
  spacer: { flexGrow: 1 },
  actionsLast: { marginBottom: 16 },
  updateBtn: {
    backgroundColor: '#A3A2FF',
    color: '#141417',
    textTransform: 'none',
    fontWeight: 700,
    borderRadius: 100,
    padding: '12px 32px',
    width: '100%',
    '&:hover': { backgroundColor: '#A3A2FF', opacity: 0.9 }
  },
  cancelBtn: {
    color: theme.text.subtitle,
    textTransform: 'none',
  }
}));

const clampTo2dp = (value) => {
  if (value == null || value === '') return ''
  const num = Number(value)
  if (Number.isNaN(num)) return ''
  return num.toFixed(2)
}

export default function EditFxDialog({ open, initialFxPercent, onBack, onClose, onUpdate }) {
  const classes = useStyles();
  const initialValue = useMemo(() => clampTo2dp(initialFxPercent ?? ''), [initialFxPercent])
  const [fx, setFx] = useState(initialValue)
  const [submitting, setSubmitting] = useState(false)

  const handleUpdate = async () => {
    setSubmitting(true)
    try {
      const parsed = fx === '' ? null : Number(fx)
      await onUpdate?.(parsed)
      onClose?.()
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} classes={{ paper: classes.root }}>
      <DialogContent>
        <div className={classes.contentWrap}>
        <div className={classes.header}>
          <div className={classes.titleRow}>
            <IconButton size="small" onClick={onBack} style={{ color: '#FDFDFD' }}>
              <ArrowBackIosIcon fontSize="small" />
            </IconButton>
          </div>
          <Typography className={classes.closeLink} onClick={onClose}>Close</Typography>
        </div>

        <Typography className={classes.title}>Edit Fees</Typography>
        <Typography className={classes.subTitle}>Update FX rate</Typography>

        <div className={classes.inputRow}>
          <TextField
            variant="filled"
            fullWidth
            value={fx}
            label="FX rate"
            placeholder="e.g. 1.00"
            onChange={(e) => {
              const val = e.target.value.replace(/[^0-9.]/g, '')
              setFx(val)
            }}
            InputProps={{
              disableUnderline: true,
              style: { color: '#FDFDFD' },
              classes: { input: classes.inputInner }
            }}
            InputLabelProps={{
              shrink: true,
              style: { color: '#A3A2FF', fontSize: 16, marginTop: -6, marginLeft: -4 }
            }}
            className={`${classes.field} ${classes.fieldFlex}`}
          />
          <Typography className={classes.percentSuffix}>%</Typography>
        </div>
        <div className={classes.spacer} />
        <div className={classes.actions}>
          <Button className={classes.updateBtn} onClick={handleUpdate} disabled={submitting}>Update</Button>
        </div>

        <div className={`${classes.actions} ${classes.actionsLast}`}>
          <Button className={classes.cancelBtn} onClick={onClose}>Cancel</Button>
        </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}


